export default {
      id: "telegram-usage",
      viewBox: "0 0 256 256",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#telegram",
      toString: function () {
        return this.url;
      }
    }